/**
 * @generated SignedSource<<d3024c2dd45ae3ce230565dce877b022>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiskCleanerInput = {
  media?: DiskCleanerMediaInput | null;
  storage?: DiskCleanerStorageInput | null;
};
export type DiskCleanerMediaInput = {
  selected?: boolean | null;
};
export type DiskCleanerStorageInput = {
  selected?: boolean | null;
};
export type DiskCleanupStorageRefetchQuery$variables = {
  input?: DiskCleanerInput | null;
  scan: boolean;
};
export type DiskCleanupStorageRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupStorage_data">;
};
export type DiskCleanupStorageRefetchQuery = {
  response: DiskCleanupStorageRefetchQuery$data;
  variables: DiskCleanupStorageRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scan"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiskCleanupStorageRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DiskCleanupStorage_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiskCleanupStorageRefetchQuery",
    "selections": [
      {
        "condition": "scan",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "DiskCleanerResult",
            "kind": "LinkedField",
            "name": "diskCleanerScan",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CleanInfo",
                "kind": "LinkedField",
                "name": "storage",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "size",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e25b003d7142ec8d17c41b02d25eae0b",
    "id": null,
    "metadata": {},
    "name": "DiskCleanupStorageRefetchQuery",
    "operationKind": "query",
    "text": "query DiskCleanupStorageRefetchQuery(\n  $input: DiskCleanerInput\n  $scan: Boolean!\n) {\n  ...DiskCleanupStorage_data\n}\n\nfragment DiskCleanupResult_cleanInfo on CleanInfo {\n  ...DiskCleanupScanInfo_scanInfo\n}\n\nfragment DiskCleanupScanInfo_scanInfo on CleanInfo {\n  count\n  size\n}\n\nfragment DiskCleanupStorage_data on Query {\n  diskCleanerScan(input: $input) @include(if: $scan) {\n    storage {\n      ...DiskCleanupResult_cleanInfo\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "637249e67e5755709c0236af7cd13e75";

export default node;
